import { Pagination, Select, Table } from 'antd';
import React from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import BreadCumbNav from '../../globalComponents/BreadCumbNav';

const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.date).toLocaleString().replace(',', '')}</span>
  },
  {
    title: 'Payment Method',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Order',
    dataIndex: 'order',
    key: 'order',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span> {new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(record.amount) } GHc</span>

  },
  
]



const PosSessionPayments = () => {
  const payments = useLoaderData();
  const navigate = useNavigate();
  const params = useParams();


  const onRow = (record, rowIndex) => {
    return {
      // onClick: () => navigate(`/purchase/purchase-orders/${params.id}/transfers/${record.number.replaceAll('/', '-')}`)
    };
  }


  return (
    <div>
      <div className='flex justify-between mx-4'>
        <BreadCumbNav />
        <div className=' bg-white dark:bg-gray-900'>

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='flex justify-end mx-4 my-2'>
        <div className=''>
          {/* <Button className='' size={'sm'}>
            <Link to={'/inventory/transfers/new'} className='w-full'>New</Link>
          </Button> */}
        </div>
        <div className='dark:bg-gray-900'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        key={'number'}
        onRow={onRow}
        rootClassName='hover:cursor-pointer'
        dataSource={payments}
        columns={columns}
        pagination={false}
      />
    </div>
  )
}

export default PosSessionPayments;